import CheckableTag from "antd/es/tag/CheckableTag";
import BaseListPresenter from "../../../components/common/BaseListPresenter";
import { formatDateObj, getLastId } from "../../../components/common/Converter";
import {
  findLabel,
  filterBySuspensionDate,
} from "./helper-payroll/HelperFunction";
import { getAssignAirport } from "./other-functions/OtherFunctions";
import InputFactory from "../../../components/InputFactory";
import { Button, dialog } from "nq-component";
import { Space, DatePicker } from "antd";
import SearchSelect from "../../../components/searchSelect/SearchSelect";
import AggregateUseCase from "../../../usecases/object/AggregateUseCase";
import { _getJobOrderEmployeesPipeline, _getSpecialPayrollEmployeesPipeline } from "../pipeline/PipelineQuery";
import {
  PAY_ITEMS,
  isAddendumBackPayItem,
  isBackPayItem,
} from "./helper-payroll/constants/payrollConstants";

class ProcessPayrollPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;

    this.payrollLabel = [
      { label: "Basic Pay", value: "BP" },
      { label: "Augmentation Pay", value: "AP" },
      // { label: "J.O Salary", value: "JO" },
      { label: "Individual Payroll", value: "IP" },
      { label: "Special Payroll", value: "SP" },
    ];
    this.payitemLabel = [
      { label: "General Payroll", value: "General Payroll" },
      { label: "Addendum Payroll", value: "Addendum Payroll" },
      { label: PAY_ITEMS.ADDENDUM_BACK_PAY, value: PAY_ITEMS.ADDENDUM_BACK_PAY },
      { label: "Newly-Hired", value: "Newly-Hired" },
      { label: PAY_ITEMS.BACK_PAY, value: PAY_ITEMS.BACK_PAY },
      { label: "Salary", value: "Salary" },
    ];
    this.individualLabel = [
      { label: "Initial Salary", value: "Initial" },
      { label: "Last Salary", value: "Last" },
      { label: "Initial Salary(AP)", value: "Initial AP" },
      { label: "Last Salary(AP)", value: "Last AP" },
      { label: "Salary Differential (Basic)", value: "SalaryDiffBasic" },
      // { label: "Salary Differential (Addendum)", value: "SalaryDiffAdd" },
      // { label: "Backwage", value: "Backwage" },
      { label: "Initial RATA", value: "Rata" },
    ];
  }

  init() {
    this.limit = 50;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.filterEarnings = {};
    this.filterEmployment = {};
    this.filterAdditional = {};
    this.filterSeperationType = {};
    this.filterSuspension = {};
    this.include = ["all"];
    this.keys = undefined;
    this.sort = { Firstname: 1, Middlename: 1, Surname: 1 };
    this.progress = true;
    this.preservedSelected = [];
    this.spAllObjects = null;
    this.selectChangeSeq = 0;
    this.incentivesPromise = null;
    this.reset();
  }

  createQuery() {
    // const skip = (this.current - 1) * this.limit;
    const { payrollTypes } = this.view.state;
    const limit = payrollTypes === "SP" ? 500 : this.limit;
    const skip = (this.current - 1) * limit;
    
    const filterConditions = {
      ...this.where,
      ...this.filter,
      ...this.filterEarnings,
      ...this.filterEmployment,
      ...this.filterAdditional,
      ...this.filterSeperationType,
      ...this.filterSuspension,
    };
    
    const hasSearch = this.search && Object.keys(this.search).length > 0 && this.search.$or;
    const hasFilters = Object.keys(filterConditions).length > 0;
    
    let where = {};
    
    if (hasSearch && hasFilters) {
      where = {
        ...filterConditions,
        ...this.search
      };
    } else if (hasSearch) {
      where = this.search;
    } else if (hasFilters) {
      where = filterConditions;
    }
    
    const query = {
      // limit: this.limit,
      limit: limit,
      skip: skip,
      where: where,
      include: this.include,
    };

    if (this.sort) {
      query.sort = this.sort;
    }
    
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    const { payrollTypes } = this.view.state;

    try {
      this.showProgress();
      this.findObjectUseCase.abort();
 
      let objects;
      if (payrollTypes === "SP") {
        // Load all via lean aggregate once, then paginate 500/page in the UI
        this.limit = 500;
        const aggregateUseCase = new AggregateUseCase();
        const pipeline = _getSpecialPayrollEmployeesPipeline({
          where: query.where,
          sort: { Firstname: 1, Middlename: 1, surname: 1 },
        });
        this.spAllObjects = await aggregateUseCase.execute(collection, pipeline);
        this.count = this.spAllObjects.length;
        this.current = 1;
        objects = this._getSPPageObjects();
        this.view.setState({ limit: 500, current: 1 });
        this.view.setCount(this.count);
      } else {
        this.spAllObjects = null;
        objects = await this.findObjectUseCase.execute(collection, query);
      }

      this.objects = objects;
 
      // const salaryMap = new Map();
      // salaryGrade.forEach((item) => {
      //   salaryMap.set(item.id, item?.["Salary Grade"]);
      // });
      // const salaryLevel = new Map(
      //   objects.map((item) => {
      //     const salaryPointer = getLastId(item?.salaryPointer);
      //     return [item.id, salaryMap.get(salaryPointer) || ""];
      //   })
      // );
 
      // const personelAirportCount = await getAssignAirport(objects);
      const isJobOrderSelected = this.view.state.jobTypeVal === "Job Order";
      let joData = [];
      if(isJobOrderSelected) {
        const aggregateUseCase = new AggregateUseCase();
        const pipeline = _getJobOrderEmployeesPipeline();
        joData = await aggregateUseCase.execute("employees", pipeline);
     
      }
  
     
      this.view.setState({ 
        // personelAirportCount: {},
        ...(isJobOrderSelected && { joData })
      }, () => {
        const payItemsOption = this.getPayItems();
        this.view.setState({ payItemsOption });
      });
 
      this.view.setObjects(objects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  _getSPPageObjects() {
    const all = this.spAllObjects || [];
    const start = (this.current - 1) * this.limit;
    return all.slice(start, start + this.limit);
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);

    // SP: slice cached aggregate results — no refetch
    if (this.view.state.payrollTypes === "SP" && this.spAllObjects) {
      this.showProgress();
      this.view.setObjects([]);
      // Brief delay so the spinner paints (same UX feel as Basic Pay)
      setTimeout(() => {
        this.objects = this._getSPPageObjects();
        this.view.setObjects(this.objects);
        this.hideProgress();
      }, 150);
      return;
    }

    this.view.setObjects([]);
    this.findObjects();
  }

  onSelect(index) {
    const selected = this.objects[index];
    const prevSelected = this.view.state.selected || [];
    const i = prevSelected.findIndex((item) => item.id === selected.id);

    let newSelected;
    if (i > -1) {
      // Remove item
      newSelected = [...prevSelected.slice(0, i), ...prevSelected.slice(i + 1)];
    } else {
      // Add item
      newSelected = [...prevSelected, selected];
    }

    this.view.setState({ selected: newSelected });
  }


  checkCase() {
    const { payrollTypes, jobTypeVal, payItems } = this.view.state;

    if (
      payrollTypes === "BP" &&
      jobTypeVal !== "Job Order" &&
      payItems === "Addendum Payroll"
    ) {
      return {
        case: "BASIC_ADDENDUM",
      };
    } else if (payrollTypes === "BP" && isAddendumBackPayItem(payItems)) {
      return {
        case: "BASIC_BACKPAY",
      };
    } else if (
      payrollTypes === "AP" &&
      (payItems === "General Payroll" || payItems === "Newly-Hired")
    ) {
      return {
        case: "AP_GENERAL_NEWLY",
      };
    } else if (
      payrollTypes === "BP" &&
      jobTypeVal === "Job Order" &&
      payItems === "Salary"
    ) {
      return {
        case: "BASIC_JO_SALARY",
      };
    } else if (
      payrollTypes === "IP" &&
      jobTypeVal !== "Job Order" &&
      (payItems === "Initial" || payItems === "Last")
    ) {
      return {
        case: "INDIVIDUAL_INITIAL_LAST",
      };
    } else if (
      payrollTypes === "IP" &&
      (payItems === "Initial AP" || payItems === "Last AP")
    ) {
      return {
        case: "INDIVIDUAL_INITIAL_LAST_AP",
      };
    } else if (
      payrollTypes === "IP" &&
      jobTypeVal === "Job Order" &&
      (payItems === "Initial" || payItems === "Last")
    ) {
      return {
        case: "INDIVIDUAL_JO_INITIAL_LAST",
      };
    } else if (payrollTypes === "AP" && isBackPayItem(payItems)) {
      return {
        case: "AP_BACKPAY",
      };
    }
  }

  onChangeFilter(type, value, field) {
    const where = {};
    switch (type) {
      case "Pointer":
        if (Object.keys(value).length > 0) {
          where[field] = { id: value.id };
        }
        break;
      case "Relation":
        if (
          Array.isArray(value) &&
          value.length > 0 &&
          typeof value[0] === "object" &&
          value[0].id
        ) {
          const ids = value.map((v) => v.id);

          where["payrollRelation"] = {
            $elemMatch: {
              id: { $in: ids },
            },
            $ne: [],
          };
        } else if (value?.id) {
          where[field] = { id: value.id };
        }
        break;
      case "StringNotEqual":
        if (Array.isArray(value)) {
          where[field] = { $nin: value };
        } else {
          where[field] = { $ne: value };
        }
        break;
      case "StringEmpty":
        where.$or = [
          { [field]: "" },
          { [field]: null },
          { [field]: { $exists: false } },
        ];
        break;
      case "BooleanNotTrue":
        where[field] = { $ne: true };
        break;
      default:
        where[field] = { $regex: value, $options: "i" };
    }
    if (field === "classification") {
      this.getfilterSubmit(where, "payrollRelation");
    } else if (field === "employmentType") {
      this.getfilterSubmit(where, field);
    } else if (field === "classificationSecond") {
      this.getfilterSubmit(where, "payrollRelation");
    } else if (field === "payrollType") {
      this.getfilterSubmit(where, field);
    } else if (field === "seperationType") {
      this.getfilterSubmit(where, field);
    }else if (field === "suspension") {
      this.getfilterSubmit(where, field);
    } else {
      this.filterSubmit(where);
    }
  }

  getfilterSubmit(where, field) {
    switch (field) {
      case "payrollRelation":
        this.filterSubmit(where);
        break;
      case "employmentType":
        this.filterSubmit2(where);
        break;
      case "classificationSecond":
        this.filterSubmit3(where);
      case "seperationType":
        this.filterSubmit4(where);
        break;
        case "suspension":
          this.filterSubmit5(where);
          break;
      default:
    }
  }

  async applyFilter(where, filterProperty) {
    const currentSelected = this.view.state.selected || [];
    if (currentSelected.length > 0) {
      this.preservedSelected = [...currentSelected];
    }
    localStorage.removeItem("currentPage");
    this.current = 1;
    this.reset();
    // this[filterProperty] = where;
     // Merge filters instead of replacing them
    const currentFilter = this[filterProperty] || {};
    const mergedFilter = { ...currentFilter };
    
    // Update or remove filter fields
    Object.keys(where).forEach(key => {
      const value = where[key];
      // Remove filter if value is empty (for regex: empty string means clear the filter)
      if (value?.$regex === '' || value === null || value === undefined || 
          (typeof value === 'object' && Object.keys(value).length === 0 && !value.id)) {
        delete mergedFilter[key];
      } else {
        mergedFilter[key] = value;
      }
    });
    
    this[filterProperty] = mergedFilter;
    await this.getObjects();
    if (this.preservedSelected.length > 0) {
      this.view.setSelected([...this.preservedSelected]);
    }
  }

  async filterSubmit(where) {
    // this.applyFilter(where, "filterEarnings");
      // Use this.filter for general text filters instead of filterEarnings
      this.applyFilter(where, "filter");
  }

  async filterSubmit2(where) {
    this.applyFilter(where, "filterEmployment");
  }

  async filterSubmit3(where) {
    this.applyFilter(where, "filterAdditional");
  }

  async filterSubmit4(where) {
    this.applyFilter(where, "filterSeperationType");
  }

  async filterSubmit5(where) {
    this.applyFilter(where, "filterSuspension");
  }

  async ensureIncentivesLists() {
    const existing = this.view.state.incentivesLists;
    if (Array.isArray(existing) && existing.length > 0) {
      return existing;
    }
    if (this.incentivesPromise) {
      return this.incentivesPromise;
    }

    this.incentivesPromise = (async () => {
      try {
        const incentives = await this.findObjectUseCase.execute("incentive", {
          keys: ["allowanceType"],
          include: ["allowanceType"],
        });
        const incentivesLists = incentives.map((item) => ({
          label: item?.allowanceType?.AllowanceType,
          value: item?.allowanceType?.AllowanceType,
          id: item.id,
        }));
        this.view.setState({ incentivesLists });
        return incentivesLists;
      } finally {
        this.incentivesPromise = null;
      }
    })();

    return this.incentivesPromise;
  }

  getPayItems(overrides = {}) {
    const { payrollTypes, incentivesLists, jobTypeVal } = {
      ...this.view.state,
      ...overrides,
    };

    // Kick off a fetch when SP options are needed but incentives aren't ready yet.
    // Callers that need the full list should await ensureIncentivesLists() first.
    if (
      payrollTypes === "SP" &&
      !(Array.isArray(incentivesLists) && incentivesLists.length > 0)
    ) {
      this.ensureIncentivesLists();
    }

    const additionalArr = [
      { label: "20% Monthly Premium", value: "20% Monthly Premium" },
    ];

    switch (payrollTypes) {
      case "BP":
        if (jobTypeVal === "Job Order") {
          return this.payitemLabel.filter(
            (item) =>
              item.value === PAY_ITEMS.BACK_PAY || item.value === "Salary"
          );
        }
        return this.payitemLabel.filter(
          (item) =>
            item.value !== "Newly-Hired" &&
            item.value !== "Salary" &&
            item.value !== PAY_ITEMS.BACK_PAY
        );

      case "AP":
        return this.payitemLabel.filter(
          (item) =>
            item.value !== PAY_ITEMS.ADDENDUM_BACK_PAY &&
            item.value !== "Addendum Payroll" &&
            item.value !== "Salary"
        );
      case "SP":
        return [...(incentivesLists || []), ...additionalArr];
      case "JO":
        return this.payitemLabel.filter(
          (item) => item.value === PAY_ITEMS.BACK_PAY || item.value === "Salary"
        );

      case "IP":
        if (jobTypeVal === "Job Order") {
          return this.individualLabel.filter(
            (item) => item.value === "Initial" || item.value === "Last"
          );
        }

        if (
          jobTypeVal === "Coterminus" ||
          jobTypeVal === "Contract of Service"
        ) {
          return this.individualLabel.filter((item) => item.value !== "Rata");
        }
        return [...this.individualLabel];
      default:
        return [];
    }
  }

  async getPayrollTypeChange(field, value, ids) {
    const relation = await this.findObjectUseCase.execute("payroll_relation", {
      keys: ["classification"],
      include: ["classification"],
      where: {
        "classification.id": { $in: ids },
      },
    });


    this.onChangeFilter("Relation", relation, "classification");
  }

  async handleSelectChange(field, value) {
    const requestId = ++this.selectChangeSeq;
    let updates = { [field]: field === "jobTypeVal" ? value.name : value };
    const { jobTypeVal, payrollTypes, incentivesLists, payrollTypeVal } =
      this.view.state;

    switch (field) {
      case "payrollTypeVal": {
        const nextPayrollTypeVal = findLabel(value, this.payrollLabel);
        const limit = value === "SP" ? 500 : 50;
        this.limit = limit;

        // Apply payroll type immediately so pay-item options aren't stale
        // and a later await can't wipe a newer job-type selection.
        updates = {
          payrollTypes: value,
          payrollTypeVal: nextPayrollTypeVal,
          limit,
          jobTypeVal: null,
          jobTypeID: null,
          payItemVal: "",
          payItems: "",
          isPayItemShow: value === "JO",
          payItemsOption: this.getPayItems({
            payrollTypes: value,
            jobTypeVal: null,
          }),
        };
        this.view.setState(updates);

        // Prefetch incentives so SP pay-item options are ready when job type is chosen
        if (value === "SP") {
          this.ensureIncentivesLists().then((lists) => {
            if (requestId !== this.selectChangeSeq) return;
            if (this.view.state.payrollTypes !== "SP") return;
            this.view.setState({
              payItemsOption: this.getPayItems({
                payrollTypes: "SP",
                jobTypeVal: this.view.state.jobTypeVal,
                incentivesLists: lists,
              }),
            });
          });
        }

        const combinations = await this.findObjectUseCase.execute(
          "payroll_combination",
          {
            keys: ["earnings"],
            where: {
              earnings: nextPayrollTypeVal,
            },
          }
        );
        if (requestId !== this.selectChangeSeq) return;

        let ids = [];
        for (const item of combinations) {
          ids.push(item.id);
        }

        if (value === "IP") {
          this.reset();
          this.filterPayrollType = {};
          this.filterEmploymentType = {};
          this.filterSeperationType = {};
          this.filterEarnings = {};
          this.onChangeFilter("String", "", "payrollType");
          this.onChangeFilter("Pointer", "", "employmentType");
          this.onChangeFilter("StringEmpty", "", "seperationType");
          this.onChangeFilter("BooleanNotTrue", true, "suspension");
        } else if (value === "SP") {
          this.reset();
          this.filterPayrollType = {};
          this.filterEmploymentType = {};
          this.filterSeperationType = {};
          this.onChangeFilter("Pointer", "", "employmentType");
        } else if (value === "JO") {
          this.filterSeperationType = {};
          this.onChangeFilter("StringEmpty", "", "seperationType");
          this.onChangeFilter("BooleanNotTrue", true, "suspension");
          this.findObjects();
        } else {
          this.filterSeperationType = {};
          this.getPayrollTypeChange("payrollType", nextPayrollTypeVal, ids);
          this.onChangeFilter("String", nextPayrollTypeVal, "payrollType");
          this.onChangeFilter("StringEmpty", "", "seperationType");
          this.onChangeFilter("BooleanNotTrue", true, "suspension");
        }
        return;
      }

      case "jobTypeVal": {
        const hasJobType = !(
          typeof value === "object" && Object.keys(value).length === 0
        );
        const nextJobType = hasJobType ? value?.name : null;
        const currentPayrollTypes = this.view.state.payrollTypes;
        let incentivesListsForOptions = this.view.state.incentivesLists;

        // SP pay items depend on incentives; wait for them if still loading
        if (currentPayrollTypes === "SP" && hasJobType) {
          incentivesListsForOptions = await this.ensureIncentivesLists();
          if (requestId !== this.selectChangeSeq) return;
        }

        updates = {
          jobTypeVal: nextJobType,
          isPayItemShow: hasJobType,
          payItemVal: "",
          payItems: "",
          jobTypeID: value?.id,
          // Refresh options immediately from BP + Job Order (don't wait for findObjects)
          payItemsOption: this.getPayItems({
            payrollTypes: currentPayrollTypes,
            jobTypeVal: nextJobType,
            incentivesLists: incentivesListsForOptions,
          }),
        };
        this.view.setState(updates);
        this.onChangeFilter("Pointer", value, "employmentType");
        return;
      }

      case "payItemVal":
        if (payrollTypes === "GP") {
          updates.payItemVal = findLabel(value, this.payitemLabel);
        } else if (payrollTypes === "SP") {
          // Include static options (e.g. 20% Monthly Premium), not only DB incentives
          const spOptions = this.getPayItems();
          const match = (incentivesLists || []).find(
            (item) =>
              typeof item === "object" &&
              (item.label === value || item.value === value)
          );
          updates.payItemVal = findLabel(value, spOptions) || value;
          updates.incentiveId = match?.id;
        } else if (payrollTypes === "AP") {
          updates.payItemVal = findLabel(value, this.payitemLabel);
        } else if (payrollTypes === "IP") {
          updates.payItemVal = findLabel(value, this.individualLabel);
        }
        updates.payItems = value;

        const combinations = await this.findObjectUseCase.execute(
          "payroll_combination",
          {
            where: {
              earnings: payrollTypeVal,
              payrollType: value,
            },
          }
        );
        if (requestId !== this.selectChangeSeq) return;

        let ids = [];
        for (const item of combinations) {
          ids.push(item.id);
        }

        const relation = await this.findObjectUseCase.execute(
          "payroll_relation",
          {
            keys: ["classification"],
            include: ["classification"],
            where: {
              "classification.id": { $in: ids },
            },
          }
        );
        if (requestId !== this.selectChangeSeq) return;

        const currentJobType = this.view.state.jobTypeVal;
        const currentPayrollTypes = this.view.state.payrollTypes;

        if (currentJobType === "Job Order" && value === PAY_ITEMS.BACK_PAY) {
          this.onChangeFilter("Relation", [], "classificationSecond");
        } else if (
          currentPayrollTypes === "BP" &&
          value === "General Payroll"
        ) {
          this.onChangeFilter("Relation", relation, "classificationSecond");
          this.onChangeFilter("BooleanNotTrue", true, "suspension");
        } else {
          this.onChangeFilter("Relation", relation, "classificationSecond");
        }

        break;

      default:
        break;
    }

    if (requestId !== this.selectChangeSeq) return;
    this.view.setState(updates);
  }

  onChangeDate(dateString, objects) {
    const [startDate, endDate] = Array.isArray(dateString)
      ? dateString
      : [null, null];

    const start = startDate ? startDate.toDate() : "";
    const end = endDate ? endDate.toDate() : "";

    const formatstart = formatDateObj(start, "Start Date");
    const formatend = formatDateObj(end, "End Date");

    const datePicked = {
      startDate: formatstart,
      endDate: formatend,
    };

    const filterEmployees = this.filterBySuspensionDate(objects, datePicked);

    this.view.setState({ datePicked, filterEmployees });
  }

  filterBySuspensionDate(objects, datePicked) {
    // const ids = objects.map((employee) => employee.id);
    // const serviceRecords = await this.fetchData(ids);

    const endDate = new Date(datePicked?.endDate);
    const endYear = endDate.getFullYear();
    const endMonth = endDate.getMonth();

    return objects.filter((emp) => {
      if (!emp.dateOfSuspension) return true;

      const suspensionDate = new Date(emp.dateOfSuspension);
      const suspensionYear = suspensionDate.getFullYear();
      const suspensionMonth = suspensionDate.getMonth();

      return (
        endYear < suspensionYear ||
        (endYear === suspensionYear && endMonth <= suspensionMonth)
      );
    });
  }

  async fetchData(ids) {
    const serviceRecords = await this.findObjectUseCase.execute(
      "service_record",
      {
        where: {
          "employee.id": { $in: ids },
        },
      }
    );
    console.log("serviceRecords", serviceRecords);
    return serviceRecords;
  }

  _handleChangeDate(value, type) {
    this.view.setState((prevState) => {
      const prevPeriod = prevState.periodCovered || {};
      let startDate = prevPeriod.startDate || "";
      let endDate = prevPeriod.endDate || "";

      if (type === "start") {
        startDate = formatDateObj(new Date(value), "Start Date");
      } else if (type === "end") {
        endDate = formatDateObj(new Date(value), "End Date");
      }

      const periodCovered = { startDate, endDate };

      return { periodCovered };
    });
  }

  handleCSVData = (csvData) => {
    this.view.setState({ csvData });
  };
  _handleInputChange(key, value) {
    this.view.setState({ [key]: value });
  }

  async _handleModalContent() {
    const { payItemVal, payrollTypes, selected } = this.view.state;
    
    const requiresSelection = 
      isAddendumBackPayItem(payItemVal) ||
      payItemVal === "Newly-Hired" ||
      isBackPayItem(payItemVal) ||
      payrollTypes === "IP" ||
      payrollTypes === "SP";
    
    if (requiresSelection && (!selected || selected.length === 0)) {
      dialog.fire({
        html: (
          <div style={{ padding: "2rem 1.5rem 1.5rem 1.5rem", minWidth: "300px" }}>
            <div 
              className="d-flex align-items-center justify-content-center"
              style={{ 
                marginBottom: "2rem",
                gap: "1rem"
              }}
            >
              <i
                className="bi bi-exclamation-circle-fill"
                style={{ 
                  color: "#ff9800",
                  fontSize: "2rem",
                  lineHeight: 1
                }}
              ></i>
              <span 
                style={{ 
                  fontSize: "1rem",
                  color: "rgba(0, 0, 0, 0.85)",
                  fontWeight: 400
                }}
              >
                Please select employees
              </span>
            </div>
            <hr style={{ margin: "0 -1.5rem 1rem -1.5rem" }} />
            <div className="w-100 d-flex justify-content-end">
              <Button
                className="btn btn-primary"
                onClick={() => dialog.close()}
                style={{
                  minWidth: "90px",
                  padding: "0.5rem 2rem",
                  fontSize: "0.9rem"
                }}
              >
                OK
              </Button>
            </div>
          </div>
        ),
        footer: false,
      });
      return;
    }
    
    this.view.setState({ 
      isModalContent: true 
    });
  }

  _handleGenerate = async () => {
    const {datePicked} = this.view.state;
    const personelAirportCount = await getAssignAirport(this.objects, datePicked);
    this.view.setState({ isFloatingForm: true, isModalContent: false, personelAirportCount });
  };

  _handleToggling(type) {
    this.view.setState({
      isFloatingForm: type === "open",
      isModalContent: false,
      payrollCode: "",
      percentage: 0,
      periodCovered: null,
      selectedYear: "",
      monthFrom: "",
      monthTo: "",
    });
  }

  async getObjects() {
    await this.countObjects();
    await this.findObjects();
  }

  searchSubmit(search) {
    this.search = search;
    this.getObjects();
  }
}

export default ProcessPayrollPresenter;
